/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * مدار المجرة — Premium SaaS Landing Page
 */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import GalaxyBackground from "./GalaxyBackground";
import LandingNav from "./LandingNav";
import LandingHero from "./LandingHero";
import WhySection from "./WhySection";
import DomainsSection from "./DomainsSection";
import StatsSection from "./StatsSection";
import StepsSection from "./StepsSection";
import PricingSection from "./PricingSection";
import ProductShowcase from "./ProductShowcase";
import TestimonialsSection from "./TestimonialsSection";
import FAQSection from "./FAQSection";
import PaymentsStrip from "./PaymentsStrip";
import FinalCTA from "./FinalCTA";
import LandingFooter from "./LandingFooter";
import "./landing.css";

export default function LandingPage() {
  const { i18n } = useTranslation();
  const isArabic = (i18n.language || "ar").startsWith("ar");

  useEffect(() => {
    document.title = isArabic ? "منصة مدار" : "Madar Platform";
  }, [isArabic]);

  return (
    <div
      className="galaxy-landing"
      dir={isArabic ? "rtl" : "ltr"}
      lang={isArabic ? "ar" : "en"}
    >
      <GalaxyBackground />
      <LandingNav isArabic={isArabic} />
      <main>
        <LandingHero isArabic={isArabic} />
        <WhySection isArabic={isArabic} />
        <StatsSection isArabic={isArabic} />
        <DomainsSection isArabic={isArabic} />
        <StepsSection isArabic={isArabic} />
        <ProductShowcase isArabic={isArabic} />
        <PricingSection isArabic={isArabic} />
        <TestimonialsSection isArabic={isArabic} />
        <PaymentsStrip isArabic={isArabic} />
        <FAQSection isArabic={isArabic} />
        <FinalCTA isArabic={isArabic} />
      </main>
      <LandingFooter isArabic={isArabic} />
    </div>
  );
}
